<template>
  <!-- 品牌图标：两个括号合成一面盾（我们的团队），里面三个方块是客户团队，橙色那块是派驻的专属安全负责人 -->
  <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <path d="M25 7H10v29l15.5 15M39 7h15v29L38.5 51" fill="none" stroke="#f79210" stroke-width="4.5" stroke-linecap="square" />
    <rect x="28" y="19" width="8" height="8" fill="#f79210" />
    <rect x="23" y="29" width="8" height="8" fill="currentColor" />
    <rect x="33" y="29" width="8" height="8" fill="currentColor" />
  </svg>
</template>
